import React , { useEffect , useState } from 'react';
import css from './index.module.scss'
const axios = require('axios');

const key = '26e5013a7bc21bc40ee691f9d8ee94e5'
const geoKey = 'fbc0a06b8c9940998ed076809ddedaa0'

function getDate(){
  let objToday = new Date();
  let dd = String(objToday.getDate()).padStart(2, '0');
  let mm = String(objToday.getMonth() + 1).padStart(2, '0'); //January is 0!
  let yyyy = objToday.getFullYear();
	let curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours());
	let curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes();
	let curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
var today = curHour + ":" + curMinute + " " + curMeridiem + ' , ' + dd + ' / ' + mm + ' / ' + yyyy
  return today
}


export default () => {

  const [ query , setQuery ] = useState(null)
  const [state , setState] = useState({
    image:null,
    date:getDate(),
    city:null,
    country:null,
    description:null,
    temperature:null,
    wind:null
  })

  useEffect(() => {
 
      axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=${geoKey}`)
     .then(({data}) => {
      axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${data.latitude}&lon=${data.longitude}&APPID=${key}`)
      .then(({data}) => {
  
        setState({
          ...state,
          city:data.name,
          country:data.sys.country,
          image:data.weather[0].icon,
          description:data.weather[0].description,
          temperature:(data.main.temp - 273.15).toFixed(1),
          wind:data.wind.speed.toFixed(0)
        })
      })
     })


   
  },[])


  const searchWeather = e => {
    axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${query}&APPID=${key}`)
    .then(({data}) => {
        if(data){
          setState({
            ...state,
            city:data.name,
            country:data.sys.country,
            image:data.weather[0].icon,
            description:data.weather[0].description,
            temperature:(data.main.temp - 273.15).toFixed(1),
            wind:data.wind.speed.toFixed(0)
          })
        }
    })
  }


const { image , date , city , country , temperature , description , wind } = state;

  return (
  
    <section className = {css.section}>
        {image && 
      <>
        <div className = {css.searchWeahter}>
            <h1>Diffrent kind of weather inside of 24/7 hours.</h1>
            <p>Yet too often some very human cultural artifacts really lead the business down the certain routes</p>
            <div className = {css.inputs}>

            <input onKeyUp = {e => e.keyCode === 13 ? searchWeather() : false} onInput = {(e) => setQuery(e.target.value)} type = 'text' placeholder = 'Search City'/>
            <button onClick = {() => searchWeather()}>Get Update</button>
            </div>
            <p>Best way to know your city weather</p>
            </div>
        <div className = {css.weatherInfo}>
            <div  className = {css.top}>
               <img alt = 'cloud' src = {`http://openweathermap.org/img/wn/${image}@2x.png`} />
               <h3>WEATHER REPORT</h3>
              <p>{date} , {city} , {country}</p>
           </div>
           <div className = {css.right}>
           <ul >
             <li>
               <img alt = 'groza' src = {require('./groza.png')} />
               <p><span>4</span>mm/h</p>
             </li>
             <li>
               <img alt = 'groza' src = {require('./sneg.png')} />
               <p><span>7</span>mph</p>
             </li>
             <li>
               <img alt = 'groza' src = {require('./viuga.png')} />
                <p><span>{wind}</span>m/s</p>
             </li>
          </ul>
           <div>
              <h4>Today's Weather Forecast</h4>
              <p>Yet too often some very human cultural artifacts really lead the business down the certain routes. Data should underlie every business decision</p>
          </div>
           </div>
          
          <div className = {css.left}>
          <img alt = 'cloud' src = {`http://openweathermap.org/img/wn/${image}@2x.png`} />
              <p>{temperature}&#176;</p>
              <p>{description}</p>
          </div>
          
        </div>
        </>
    }
    {!image && <p className = {css.loading}>Loading...</p>}
    </section>
)}